import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from '../shared/dto-has-api.model';

@Api('api/app/configuration-settings/language-code')
export class CallLanguageCodeDto extends DtoHasApi {
  id: number;
  name: string;
  code: string;
  isVisible: boolean;
  disabled: boolean;
  isDeleted: boolean;
}
